// NGRX
import { createSelector } from '@ngrx/store';
import { AppState } from '../reducers';
import { BlockUIState } from '../reducers/blockui.reducers';

// For selector
export const selectBlockUIState: (state: AppState) => BlockUIState = (state: AppState): BlockUIState => state.blockUI;

export const getBlockUI = createSelector(selectBlockUIState, store => store);
